module.exports = __webpack_public_path__ + "static/img/sec2-bg@m.702aed2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec2-bg@m.png
// module id = LD+z
// module chunks = 0